const FRAMEWORK_MAPPING_TYPES = {
  DOMINANT: 'DOMINANT',
  NON_DOMINANT: 'NON_DOMINANT'
};

export { FRAMEWORK_MAPPING_TYPES };
